'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _itemDetail = require('./remote/itemDetail');

var ItemDetail = {
    fetchItemDetailsByIds: _itemDetail.ItemDetailRemote.fetchItemDetailsByIds
};

exports.default = ItemDetail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/itemDetail.js
// module id = /L+n
// module chunks = 60